(function (Drupal, drupalSettings) {
  Drupal.behaviors.serviceTabs = {
    attach: function (context, settings) {
      const serviceTabsElements = context.querySelectorAll(".service-tabs");
      serviceTabsElements.forEach((serviceTabs) => {
        if (!serviceTabs.dataset.serviceTabsProcessed) {
          serviceTabs.dataset.serviceTabsProcessed = "true";

          const links = serviceTabs.querySelectorAll("li a");
          const serviceContents = context.querySelectorAll(
            ".service-contents > div"
          );

          if (window.location.hash) {
            const hashLink = window.location.hash.substring(1);
            const activeLink = serviceTabs.querySelector(
              `li a[data-link='${hashLink}']`
            );
            const activeContent = context.querySelector(
              `.service-contents > div.${hashLink}`
            );

            if (activeLink) activeLink.classList.add("active");
            if (activeContent) activeContent.classList.add("active");
          } else {
            const firstTab = serviceTabs.querySelector("li:first-child a");
            const firstContent = context.querySelector(
              ".service-contents > div:first-child"
            );

            if (firstTab) firstTab.classList.add("active");
            if (firstContent) firstContent.classList.add("active");
          }

          links.forEach((link) => {
            link.addEventListener("click", (e) => {
              e.preventDefault();

              const toLink = link.getAttribute("data-link");

              links.forEach((l) => l.classList.remove("active"));
              link.classList.add("active");

              serviceContents.forEach((content) =>
                content.classList.remove("active")
              );
              const targetContent = context.querySelector(
                `.service-contents > div.${toLink}`
              );
              if (targetContent) targetContent.classList.add("active");
            });
          });
        }
      });
    },
  };
})(Drupal, drupalSettings);
